import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import styled from "@emotion/styled";
import { CircularProgress } from "@mui/material";

import {
  ScheduleDashboard,
  ScheduleListCalendar,
  PageHeader,
} from "@/components";

import { useFetchSchedules } from "@/hooks/schedule/use-fetch-schedules";
import { useCustomTranslation } from "@/utils/useCustomTranslation";

export const MyScheduleTemplate = () => {
  const { t } = useCustomTranslation();
  const [selectedDate, setSelectedDate] = useState<Dayjs>(dayjs());
  const [selectedMonth, setSelectedMonth] = useState<Dayjs>(dayjs());

  const {
    data: schedules,
    isLoading,
    isError,
  } = useFetchSchedules("student", selectedMonth);

  const handleDateChange = (date: Dayjs) => {
    setSelectedDate(date);
  };

  const handleMonthChange = (date: Dayjs) => {
    setSelectedDate(date);
    setSelectedMonth(date);
  };

  if (isError) {
    return <ErrorContainer>Error</ErrorContainer>;
  }

  return (
    <Container>
      <PageHeader title={t("schedule")} />
      <ContentWrapper>
        <CalendarSection>
          <ScheduleListCalendar
            selectedDate={selectedDate}
            onDateChange={handleDateChange}
            onMonthChange={handleMonthChange}
            scheduleDates={
              schedules?.map((schedule) => dayjs(schedule.startsAt)) || []
            }
            isLoading={isLoading}
          />
        </CalendarSection>
        <DashboardSection>
          {isLoading ? (
            <LoadingWrapper>
              <CircularProgress />
            </LoadingWrapper>
          ) : (
            <ScheduleDashboard
              schedules={schedules || []}
              selectedDate={selectedDate}
            />
          )}
        </DashboardSection>
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

const CalendarSection = styled.div`
  flex: 1;
  min-width: 300px;
  margin-right: 24px;
`;

const DashboardSection = styled.div`
  flex: 3;
  // margin-left: 24px;
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

const ErrorContainer = styled.div`
  color: ${({ theme }) => theme.colors.state.error};
  text-align: center;
  padding: 24px;
`;
